import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inlineList = _resolveComponent("inlineList")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_proteinVeggieSelection = _resolveComponent("proteinVeggieSelection")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_modalWrapper = _resolveComponent("modalWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.justModal)
      ? (_openBlock(), _createBlock(_component_ion_row, {
          key: 0,
          class: "full-width topping-modal-btn"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              button: "",
              detail: "",
              class: "full-width",
              "data-cy": "topping-modal-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalOpen = !_ctx.modalOpen))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-padding-start" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.btnName) + " ", 1),
                    (_ctx.showToppingPreview)
                      ? (_openBlock(), _createBlock(_component_inlineList, {
                          key: 0,
                          items: _ctx.localToppings?.filter((c) => c.selected),
                          keyName: "name",
                          "data-cy": "inline-toppings",
                          displayFunc: _ctx.inlineToppingDisplay
                        }, null, 8, ["items", "displayFunc"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_modalWrapper, {
      title: "Toppings",
      open: _ctx.modalOpen,
      onClose: _ctx.close,
      onDismiss: _ctx.close,
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('confirm', $event))),
      "data-cy": "topping-modal"
    }, {
      default: _withCtx(() => [
        (_ctx.copy)
          ? (_openBlock(), _createBlock(_component_proteinVeggieSelection, {
              key: 0,
              availableTopping: _ctx.availableTopping,
              toppings: _ctx.copy,
              "onUpdate:toppings": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.copy) = $event)),
              initialItem: _ctx.initialItem,
              class: "protein-veggie list-buffer",
              hideSplitOpts: _ctx.hideSplitOpts,
              checklistClass: "ion-padding",
              parentToppingCount: _ctx.parentToppingCount,
              onBlockSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.disabled = $event)),
              checkCount: "",
              ignoreTopping: _ctx.toppingCount - _ctx.parentToppingCount
            }, null, 8, ["availableTopping", "toppings", "initialItem", "hideSplitOpts", "parentToppingCount", "ignoreTopping"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_ion_button, {
          color: "primary",
          expand: "full",
          size: "large",
          class: "force-bottom interstate-bold full-width ma-0",
          onClick: _ctx.add,
          "data-cy": "button-add-toppings",
          disabled: _ctx.disabled
        }, {
          default: _withCtx(() => [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_ion_spinner, {
                  key: 0,
                  name: "lines-small"
                }))
              : (_openBlock(), _createBlock(_component_ion_text, { key: 1 }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Update Toppings")
                  ])),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      _: 1
    }, 8, ["open", "onClose", "onDismiss"])
  ], 64))
}